var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"info":_vm.info.config,"index":_vm.index},on:{"close":_vm.close,"add":_vm.add},model:{value:(_vm.searchModal),callback:function ($$v) {_vm.searchModal=$$v},expression:"searchModal"}})}
var staticRenderFns = []

export { render, staticRenderFns }